import React from "react";
// UI Framework
import { Checkbox } from "antd";
// Common Components
import {
  DynamicMultiSelectDropdown,
  FileDownloader,
  StaticDropdown,
} from "src/Components";
import TableTemplate from "src/Tables/TableTemplate/tableTemplate";
// Local Components
import AllocationTableUI from "./AllocationTableUI";
import {
  getAllocationAssetTypesDropDown,
  getPortfoGroupAllocationTable,
  getPortfoGroupallocationExcel,
} from "src/Requests/portfolioGroups";
import PortfolioFilterMultiSelects from "../PortfolioFilterMultiSelects";
import type {
  IPortfoGroupAllocationSearchParams,
  IPortfoGroupAllocationTableReport,
} from "src/Interfaces/portfolioGroups";
import { portfolioGroupExchangeTypeOptions } from "src/Utils/exchangeTypeOptions";

const StatusSummary = () => {
  const [searchParams, setSearchParams] =
    React.useState<IPortfoGroupAllocationSearchParams>({
      portfoGroupIds: [],
      accountIds: [],
      exchangeType: null,
      assetTypes: [],
      showZeroValueAssetTypes: false,
    });

  const checkboxChangeHandler = (name: string, checked: boolean) => {
    setSearchParams((prev) => ({
      ...prev,
      [name]: checked,
    }));
  };

  const multiSelectFilterChangeHandler = (
    name: "portfoGroupIds" | "accountIds",
    value: string[],
  ) => {
    setSearchParams((prev) => ({ ...prev, [name]: value.map(Number) }));
  };

  const assetTypeFilterChangeHandler = (_: string, value: string[]) => {
    setSearchParams((prev) => ({ ...prev, assetTypes: value.map(Number) }));
  };

  const exchangeTypeChangeHandler = (_: string, value: number | string) => {
    setSearchParams((prev) => ({
      ...prev,
      exchangeType: value === "" || value == null ? null : Number(value),
    }));
  };

  return (
    <div className="flex flex-col flex-1 w-full gap-3">
      <div className="flex flex-row justify-start items-end gap-3">
        <PortfolioFilterMultiSelects
          portfoGroupIds={searchParams.portfoGroupIds ?? []}
          accountIds={searchParams.accountIds ?? []}
          onChange={multiSelectFilterChangeHandler}
        />
        <div className="w-[220px]">
          <StaticDropdown
            dropdown={{
              name: "exchangeType",
              placeholder: "بورس",
              extraLabel: true,
            }}
            options={portfolioGroupExchangeTypeOptions}
            onChange={exchangeTypeChangeHandler}
            value={searchParams.exchangeType?.toString() ?? ""}
          />
        </div>
        <div className="w-[240px]">
          <DynamicMultiSelectDropdown
            dropdown={{
              name: "assetTypes",
              placeholder: "طبقه دارایی / استراتژی",
              extraLabel: true,
            }}
            getData={getAllocationAssetTypesDropDown}
            onChange={assetTypeFilterChangeHandler}
            value={searchParams.assetTypes ?? []}
            withSelectAll
          />
        </div>
        <div className="w-36">
          <FileDownloader getFile={() => getPortfoGroupallocationExcel(searchParams)} />
        </div>
      </div>
      <div className="min-h-8 flex items-center mb-2">
        <Checkbox
          checked={!!searchParams.showZeroValueAssetTypes}
          onChange={(event) =>
            checkboxChangeHandler(
              "showZeroValueAssetTypes",
              event.target.checked,
            )
          }
        >
          نمایش طبقه های با مقدار صفر
        </Checkbox>
      </div>
      <TableTemplate<
        IPortfoGroupAllocationSearchParams,
        IPortfoGroupAllocationTableReport
      >
        getDataTable={getPortfoGroupAllocationTable}
        searchParameters={searchParams}
        TableUI={({ reports, onAction, sortingType, setSortingType }) => (
          <AllocationTableUI
            reports={reports}
            onAction={onAction}
            sortingType={sortingType}
            setSortingType={setSortingType}
            compactPercentAndExpandValue
            autoSizeAccountColumns
            tableBoxClassName="max-h-[800px] portfolio-group-first-row"
          />
        )}
        refreshTableTime={30000}
        pagesize={200}
        withSort
        tableWrapperClassname="!mx-0"
      />
    </div>
  );
};

export default StatusSummary;
